import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';
import { isAreaAdmin, isSuperAdmin } from 'utils/utils';

let redirectAfterLogin = '';
const NonAuthLayout = () => {
  const { authToken, userData } = useSelector((store) => store.auth);

  redirectAfterLogin =
    isSuperAdmin(userData?.roles) || isAreaAdmin(userData?.roles)
      ? '/Stores'
      : '/StoreInfo/projects';

  return <>{authToken ? <Navigate to={redirectAfterLogin} replace={true} /> : <Outlet />}</>;
};

export default NonAuthLayout;
